import React from 'react';
import {
  HelpRoundedIcon,
  Tooltip,
  TooltipPlacementEnum,
} from '@unisporkal/alliance-ui';
import cx from 'classnames';
import styles from './InfoTooltip.module.scss';

interface InfoTooltipProps {
  placement?: TooltipPlacementEnum;
  content: React.ReactNode;
  trackViewed?: () => void;
  className?: string;
  tooltipClassName?: string;
}

const InfoTooltip = ({
  placement = TooltipPlacementEnum.BOTTOM,
  content,
  trackViewed = () => null,
  className = undefined,
  tooltipClassName = undefined,
}: InfoTooltipProps) => (
  <span className={cx(styles.tooltipParent, className)}>
    <Tooltip
      placement={placement}
      content={content}
      className={cx(styles.tooltipContent, tooltipClassName)}
      onOpenChange={(open) => {
        if (open) trackViewed();
      }}
    >
      <HelpRoundedIcon />
    </Tooltip>
  </span>
);

export default InfoTooltip;
